module.exports = __webpack_public_path__ + "img/90-thickbox_default.3e0cc3aa.jpg";